const insertIntoArray = (index: number, array: any[], arrayToInsert: any[]) => {
  let newArray = [...array]
  newArray.splice(index, 0, ...arrayToInsert)
  return newArray
}

export default insertIntoArray
